// this is for a new Form
export interface NewFormProps {
  formData: mumms.FormEntity;
}

// this is for a form in progress
export interface WIPFormProps {
  formData: mumms.GenericForm;
}
export type FormProps = NewFormProps & WIPFormProps;

// drawmode indicate if horizontal drawing
export const horizontal = 'horizontal';
// todo in common utils
// FORMS control types
export const label = 'label';
export const input = 'input';
export const date = 'date';
export const signature = 'signature';
export const radio = 'radio';
export const singleselect = 'singleselect';
export const multiselect = 'multiselect';
export const checkbox = 'checkbox';
export const statement = 'statement';
export const map = 'map';

// FORMS css
export const bullet = 'bullet';
export const isonerequired = 'isonerequired';

export const widthMultiplier = 8.75;
export const topFormSectionID = 'top-form-section';
